/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-11-14 11:43:22
 * @LastEditors: linxi
 * @LastEditTime: 2023-07-24 14:02:51
 */
import { Button, Col, Form, Modal, notification, Row, Select, Spin, Tooltip } from 'antd'
import React, { ReactElement, useContext, useEffect, useRef, useState } from 'react'
import styles from './unexecutedPrescription.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { getRecipeCategoryName } from '../../../../models/recipe'
import { ThemeContext } from '../../../../theme/ThemeContext'
import { EditableList } from '../../../../compnents/list/EditableList'
import { Columns } from './column'
import { ExcuteDetailModal } from './recordOfExecutionModal'
import { BatchExcuteModal } from './ExecutionModal'
import { unwrapResult } from '@reduxjs/toolkit'
import { getExecuteSubmit } from './unexecutedPrescriptionSlice'
import { PrintTemplateCategory } from '../../../../models/print'
import { getPrintZXDData } from '../../../treatment/editor/recipeEditorSlice'
import { PrintTemplateModal } from '../../../print/PrintTemplateModal'
import { NoDataIcon } from '../../../../compnents/icons/Icons'
import { getUsersInDepartmentAsync } from '../../../completion/completionSlice'
import { StationCategory } from '../../../../models/user'
import { selectUserId } from '../../../../app/applicationSlice'
import { ExclamationCircleFilled } from '@ant-design/icons'
import moment from 'moment'
import { DateTimeFormatSimples } from '../../../../models/datetime'

const { Option } = Select

interface RecipeListItemProps {
  loading?: boolean
  patientId?: any
  data: any
  selectTabKey?: string
  refresh?: () => void
}

export const RecipeListItem = ({
  loading,
  patientId,
  data = [],
  selectTabKey,
  refresh,
}: RecipeListItemProps): ReactElement => {

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 },
  }

  const theme = useContext(ThemeContext);

  const [form] = Form.useForm()

  const UserId = useSelector(selectUserId)

  const dispatch = useDispatch<RootDispatch>()

  const [treatmentId, setTreatmentId] = useState<any>()

  const [isPrintModalVisible, setIsPrintModalVisible] = useState(false)

  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false)

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [recordId, setRecordId] = useState('')

  const [recipeId, setRecipeId] = useState('')

  const [paymentId, setPaymentId] = useState('')

  const [recipeItemId, setRecipeItemId] = useState('')

  const [isBatchExcuteModalVisible, setIsBatchExcuteModalVisible] = useState(false)

  const [singleState, setSingleState] = useState(true)

  const [printZXDData, setPrintZXDData] = useState<any>()

  const [assistantList, setAssistantList] = useState<any>()

  const [recipeExecuteVOList, setRecipeExecuteVOList] = useState<any>()

  const getReciptPrintList = (recipeId?: any) => {
    dispatch(getPrintZXDData(recipeId))
      .then(unwrapResult)
      .then((v: any) => {
        setPrintZXDData(v)
      })
  }

  const getZXRList = () => {
    dispatch(
      getUsersInDepartmentAsync({
        departmentId: '',
        stationCategory: StationCategory.DoctorOrPharmacist,
        multyStationCategory: '0,1',
      })
    )
      .then(unwrapResult)
      .then((res) => {
        setAssistantList(res)
        const operatorId = res?.find((v: any) => v?.id == UserId.toString())?.id ? [UserId.toString()] : []
        form.setFieldsValue({
          operatorId: operatorId,
        })
      })
  }
  useEffect(() => {
    if (isConfirmModalVisible) {
      getZXRList()
    }
  }, [isConfirmModalVisible])

  return (
    <>
      <Spin spinning={loading} style={{ paddingTop: '100px' }}>
        {data?.length ? data?.map((v: any, index: number) => {
          return <div
            key={index}
            className={styles.recipelistItemMain}
          >
            <Row className={styles.recipelistItemTitleRow}
              style={{
                backgroundColor: theme.th,
              }}>
              <Col span={12}>
                <span style={{ fontWeight: 'bold' }}>{getRecipeCategoryName(v.category)}</span>，处方编号：
                {v.recipeId} <span style={{ color: v?.feesStatus == 0 ? '#FA8714' : v?.feesStatus == 5 ? 'red' : '#999999', marginLeft: '6px' }}>{v?.feesStatus == 0 ? '待收费' : v?.feesStatus == 3 ? '已结算' : v?.feesStatus == 5 ? '已退费' : ''}</span>
              </Col>
              <Col span={12} className={styles.recipelistItemTitleButton}>
                {/* selectTabKey == 1 已执行 或 feesStatus == 5 已退费 */}
                {selectTabKey == '1' || v?.feesStatus == 5 ? '' : <>
                  <Button
                    type="primary"
                    ghost
                    style={{ marginRight: 10 }}
                    onClick={() => {
                      setIsConfirmModalVisible(true)
                      setRecipeExecuteVOList(v?.recipeExecuteVOList || [])
                    }}>全部执行</Button>
                  <Button
                    type="primary"
                    style={{ marginRight: 10 }}
                    onClick={() => {
                      setIsBatchExcuteModalVisible(true)
                      setSingleState(false)
                      setRecipeId(v.recipeId)
                    }}
                  >批量执行</Button>
                </>}
                <Button
                  type="primary"
                  onClick={() => {
                    const recipeId = v.recipeId
                    const paymentId = v.paymentId
                    const treatmentId = v?.treatmentId
                    if (recipeId) {
                      setRecipeId(recipeId)
                      setPaymentId(paymentId)
                      setTreatmentId(treatmentId)
                      if (recipeId) {
                        getReciptPrintList(recipeId)
                      }
                      setIsPrintModalVisible(true)
                    }
                  }
                  }>打印
                </Button>
              </Col>
            </Row>
            <EditableList
              bordered
              pagination={false}
              page={{
                items: v?.recipeExecuteVOList || [],
                current: 1,
                size: 10,
                total: 0,
              }}
              columns={Columns((text, t) => {
                if (text == 'execute') {
                  setIsBatchExcuteModalVisible(true)
                  setRecipeItemId(t.recipeItemId)
                  setRecipeId(v.recipeId)
                  setSingleState(true)
                } else if (text == 'record') {
                  setIsModalVisible(true)
                  setRecordId(t?.id)
                }
              }, selectTabKey,v?.feesStatus)}
            />

          </div >
        }) : <div className={styles.noPageData}>
          <NoDataIcon
            style={{
              width: 200,
              height: 200,
              opacity: 0.5,
            }}
          />
          <span>暂无数据</span>

        </div>}
      </Spin >
      {/* 记录 */}
      < ExcuteDetailModal
        id={recordId}
        isModalVisible={isModalVisible}
        onOk={(() => {
          setIsModalVisible(false)
        })}
        onCancel={(() => {
          setIsModalVisible(false)
        })}
      />

      {/* 执行 */}
      <BatchExcuteModal
        singleState={singleState}
        recipeId={recipeId}
        recipeItemId={recipeItemId}
        isModalVisible={isBatchExcuteModalVisible}
        onOk={(() => {
          setIsBatchExcuteModalVisible(false)
          setRecordId('')
          refresh && refresh()
        })}
        onCancel={(() => {
          setIsBatchExcuteModalVisible(false)
          setRecordId('')
        })}
      />
      <PrintTemplateModal
        recipeId={recipeId}
        printZXDData={printZXDData}
        pagePrintFlag={'zxdPrint'}
        paymentId={paymentId}
        templateCategory={PrintTemplateCategory.CFDY}
        visible={isPrintModalVisible}
        treatmentId={treatmentId}
        onCancel={() => setIsPrintModalVisible(false)}
      />
      <Modal
        destroyOnClose
        title='全部执行'
        visible={isConfirmModalVisible}
        onOk={(() => {
          form.submit()
        })}
        onCancel={(() => {
          setIsConfirmModalVisible(false)
          setRecipeExecuteVOList([])
          form.resetFields()
        })}>
        <div style={{ marginBottom: '20px', display: 'flex', }}>
          <div><ExclamationCircleFilled style={{ color: '#FFAE55', fontSize: 20, marginRight: '10px' }} /></div>
          <div>全部执行后，当前处方单里的所有项目执行进度全部完成，请确认是否要全部执行？</div>
        </div>
        <Form
          form={form}
          onFinish={(values) => {
            const data = assistantList.filter((item: any) =>
              values.operatorId.includes(item.id)
            )
            const operatorName = data.map((item: any) => item.name)
            const params = recipeExecuteVOList?.map((item: any) => ({
              ...item,
              executeAll: true,
              workstationId: item?.id,
              executeTime: item?.executeTime ? moment(item?.executeTime).format(DateTimeFormatSimples) : moment().format(DateTimeFormatSimples),
              operatorId: values?.operatorId?.length
                ? values?.operatorId?.join(',')
                : '',
              operatorName: operatorName?.length
                ? operatorName?.join(',')
                : '',
            }))
            dispatch(getExecuteSubmit(
              params
            ))
              .then(unwrapResult)
              .then((v) => {
                notification.success({
                  message: '操作成功',
                })
                refresh && refresh()
              })
              .finally(() => {
                setRecipeExecuteVOList([])
                form.resetFields()
                setIsConfirmModalVisible(false)
              })
          }}>
          <Form.Item
            {...layout}
            name='operatorId'
            label='执行人：'
            rules={[{ required: true, message: '请选择执行人' }]}
          >
            <Select
              mode='multiple'
              placeholder='执行人'
              allowClear
            >
              {assistantList?.map((v: any) => (
                <Option key={v.id?.toString()} value={v.id?.toString()}>
                  {v.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
